$(function() {
  'use strict';
  
  var slider_options_defaults = {
    speed: 400,
    grabCursor: true,
    keyboardControl: true
  };

  $('.swiper-container').each(function() {
    var $slider_container = $(this);
    var slider_opts = Object.create(slider_options_defaults);

    if($slider_container.hasClass("autoplay")) {
      var autoplay_speed = $slider_container.data("autoplay-speed");
      slider_opts.autoplay = typeof autoplay_speed != 'undefined' ? autoplay_speed : 3000; 
      slider_opts.autoplayDisableOnInteraction = false;
    }

    if($slider_container.hasClass("arrows")) {
      slider_opts.prevButton = '.arrow-prev';
      slider_opts.nextButton = '.arrow-next';
    }

    if($slider_container.hasClass("vertical")) {
      slider_opts.direction = 'vertical';
    }

    if($slider_container.hasClass("loop")) {
      slider_opts.loop = true;
    }

    if($slider_container.hasClass("fade")) {
      slider_opts.effect = 'fade';
      slider_opts.fade = {
        crossfade: true
      };
    }

    if($slider_container.hasClass("pagination")) {
      slider_opts.pagination = '.carousel-pagination';
      slider_opts.paginationClickable = true;
    }

    if($slider_container.hasClass("single-slide")) {
      slider_opts.simulateTouch = false;
      slider_opts.loop = false;
      slider_opts.grabCursor = false;
      slider_opts.effect = 'fade';
      slider_opts.fade = {
        crossfade: true
      };
    }
  
    

    // $slider_container.on('beforeChange', function(event, slick, currentSlide){
    //   //pause video on slide change
    //   var $slide_obj = $slider_container.find("[data-slick-index='" + currentSlide + "']");
    //   var $video = $slide_obj.find('video');
    //   if(typeof $video != 'undefined' && $video.length) {
    //     $video.get(0).pause();
    //   } 
    // });

    //  $slider_container.on('init', function(event){
    //   //play video on carousel load if available
    //   var $slide_obj = $slider_container.find("[data-slick-index='0']");
    //   var $video = $slide_obj.find('video');
    //   if(typeof $video != 'undefined' && $video.length) {
    //     $video.get(0).play();
    //   } 

    //initialise each slider
    var this_slider = new Swiper($slider_container,slider_opts);


    $slider_container.on('slideChangeEnd', function(){
    //   //play video on slide change
    //   var $slide_obj = $slider_container.find("[data-slick-index='" + currentSlide + "']");
    //   var $video = $slide_obj.find('video');
    //   if(typeof $video != 'undefined' && $video.length) {
    //     $video.get(0).play();
    //   } 
    });
  });
});